module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(3);
}, /* 1 */
, /* 2 */
, /* 3 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.StatelessSelect = void 0;
    var _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _StatelessSelect = __webpack_require__(10), _StatelessSelect2 = _interopRequireDefault(_StatelessSelect), _appearances = __webpack_require__(24), AkSingleSelect = function(_PureComponent) {
        function AkSingleSelect() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, AkSingleSelect);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AkSingleSelect.__proto__ || (0, 
            _getPrototypeOf2.default)(AkSingleSelect)).call.apply(_ref, [ this ].concat(args))), 
            _this.state = {
                isOpen: _this.props.isDefaultOpen,
                selectedItem: _this.props.defaultSelected,
                filterValue: _this.props.defaultSelected ? _this.props.defaultSelected.content : ""
            }, _this.selectItem = function(item) {
                _this.setState({
                    isOpen: !1,
                    selectedItem: item
                }), _this.props.onSelected({
                    item: item
                });
            }, _this.handleOpenChange = function(attrs) {
                _this.setState({
                    isOpen: attrs.isOpen
                }), _this.props.onOpenChange(attrs);
            }, _this.handleFilterChange = function(value) {
                _this.props.onFilterChange(value), _this.setState({
                    filterValue: value
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(AkSingleSelect, _PureComponent), (0, _createClass3.default)(AkSingleSelect, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(_StatelessSelect2.default, {
                    appearance: this.props.appearance,
                    filterValue: this.state.filterValue,
                    hasAutocomplete: this.props.hasAutocomplete,
                    id: this.props.id,
                    isDisabled: this.props.isDisabled,
                    isFirstChild: this.props.isFirstChild,
                    isInvalid: this.props.isInvalid,
                    isOpen: this.state.isOpen,
                    isRequired: this.props.isRequired,
                    items: this.props.items,
                    label: this.props.label,
                    name: this.props.name,
                    noMatchesFound: this.props.noMatchesFound,
                    onFilterChange: this.handleFilterChange,
                    onOpenChange: this.handleOpenChange,
                    onSelected: this.selectItem,
                    placeholder: this.props.placeholder,
                    position: this.props.position,
                    selectedItem: this.state.selectedItem,
                    shouldFitContainer: this.props.shouldFitContainer,
                    shouldFocus: this.props.shouldFocus
                });
            }
        } ]), AkSingleSelect;
    }(_react.PureComponent);
    AkSingleSelect.propTypes = {
        appearance: _react.PropTypes.oneOf(_appearances.appearances.values),
        defaultSelected: _StatelessSelect.itemShape,
        hasAutocomplete: _react.PropTypes.bool,
        id: _react.PropTypes.string,
        isFirstChild: _react.PropTypes.bool,
        isDisabled: _react.PropTypes.bool,
        isDefaultOpen: _react.PropTypes.bool,
        isRequired: _react.PropTypes.bool,
        isInvalid: _react.PropTypes.bool,
        items: _react.PropTypes.array,
        // eslint-disable-line react/forbid-prop-types
        label: _react.PropTypes.string,
        name: _react.PropTypes.string,
        noMatchesFound: _react.PropTypes.string,
        onFilterChange: _react.PropTypes.func,
        onSelected: _react.PropTypes.func,
        onOpenChange: _react.PropTypes.func,
        placeholder: _react.PropTypes.string,
        position: _react.PropTypes.string,
        shouldFitContainer: _react.PropTypes.bool,
        shouldFocus: _react.PropTypes.bool
    }, AkSingleSelect.defaultProps = {
        appearance: _appearances.appearances.default,
        isOpen: !1,
        isRequired: !1,
        items: [],
        label: "",
        onFilterChange: function() {},
        onItemActivated: function() {},
        onOpenChange: function() {},
        onSelected: function() {},
        placeholder: "",
        position: "bottom left",
        shouldFocus: !1
    }, exports.default = AkSingleSelect, exports.StatelessSelect = _StatelessSelect2.default;
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 10 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.itemShape = void 0;
    var _defineProperty2 = __webpack_require__(11), _defineProperty3 = _interopRequireDefault(_defineProperty2), _extends2 = __webpack_require__(12), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _droplist = __webpack_require__(13), _droplist2 = _interopRequireDefault(_droplist), _droplistItem = __webpack_require__(14), _droplistItem2 = _interopRequireDefault(_droplistItem), _droplistGroup = __webpack_require__(15), _droplistGroup2 = _interopRequireDefault(_droplistGroup), _fieldBase = __webpack_require__(16), _styles = __webpack_require__(17), _styles2 = _interopRequireDefault(_styles), _classnames = __webpack_require__(21), _classnames2 = _interopRequireDefault(_classnames), _expand = __webpack_require__(22), _expand2 = _interopRequireDefault(_expand), _NothingWasFound = __webpack_require__(23), _NothingWasFound2 = _interopRequireDefault(_NothingWasFound), _appearances = __webpack_require__(24), itemShape = exports.itemShape = _react.PropTypes.shape({
        content: _react.PropTypes.node,
        value: _react.PropTypes.oneOfType([ _react.PropTypes.string, _react.PropTypes.number ]),
        isDisabled: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        elemBefore: _react.PropTypes.node,
        elemAfter: _react.PropTypes.node
    }), StatelessSelect = function(_PureComponent) {
        function StatelessSelect() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, StatelessSelect);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatelessSelect.__proto__ || (0, 
            _getPrototypeOf2.default)(StatelessSelect)).call.apply(_ref, [ this ].concat(args))), 
            _this.state = {
                isFocused: _this.props.isOpen
            }, _this.componentDidMount = function() {
                _this.state.isFocused && _this.inputNode && _this.inputNode.focus();
            }, _this.componentDidUpdate = function(prevProps) {
                !prevProps.shouldFocus && _this.props.shouldFocus && _this.inputNode && _this.inputNode.focus();
            }, _this.onFocus = function() {
                _this.props.isDisabled || (_this.setState({
                    isFocused: !0
                }), _this.inputNode && _this.inputNode.focus());
            }, _this.onBlur = function() {
                _this.props.isDisabled || _this.setState({
                    isFocused: !1
                });
            }, _this.onOpenChange = function(attrs) {
                _this.props.onOpenChange(attrs), _this.setState({
                    focusedItemIndex: void 0
                }), _this.inputNode && _this.inputNode.focus();
            }, _this.getNextFocusable = function(indexItem, length) {
                var currentItem = indexItem;
                return void 0 === currentItem ? currentItem = 0 : currentItem < length ? currentItem++ : currentItem = 0, 
                currentItem;
            }, _this.getPrevFocusable = function(indexItem, length) {
                var currentItem = indexItem;
                return currentItem > 0 ? currentItem-- : currentItem = length, currentItem;
            }, _this.getAllItems = function(groups) {
                var allItems = [];
                return groups.forEach(function(val) {
                    allItems = allItems.concat(val.items);
                }), allItems;
            }, _this.getAllVisibleItems = function(groups) {
                return _this.filterItems(_this.getAllItems(groups));
            }, _this.getNextNativeSearchItem = function(items, key, currentIndex, isSecondStep) {
                var res = items.find(function(item, index) {
                    var content = item.content && item.content.toLowerCase();
                    return !(index <= currentIndex) && (content && 0 === content.indexOf(key.toLowerCase()));
                });
                return res || isSecondStep || (res = _this.getNextNativeSearchItem(items, key, -1, !0)), 
                res;
            }, _this.clearNativeSearch = function() {
                _this.nativeSearchKey = "", _this.nativeSearchCounter = void 0;
            }, _this.filterItems = function(items) {
                var value = _this.props.filterValue, trimmedValue = value && value.toLowerCase().trim(), selectedItem = _this.props.selectedItem, unselectedItems = items.filter(function(item) {
                    return selectedItem.value !== item.value;
                });
                return trimmedValue && trimmedValue !== (selectedItem.content && selectedItem.content.toLowerCase()) ? unselectedItems.filter(function(item) {
                    return item.content.toLowerCase().indexOf(trimmedValue) > -1;
                }) : unselectedItems;
            }, _this.scrollToFocused = function(index) {
                var scrollable = _this.containerNode.querySelector('[data-role="droplistContent"]'), item = void 0;
                scrollable && void 0 !== index && (item = scrollable.querySelectorAll('[data-role="droplistItem"]')[index]), 
                item && scrollable && (scrollable.scrollTop = item.offsetTop - scrollable.clientHeight + item.clientHeight);
            }, _this.focusNextItem = function() {
                var filteredItems = _this.getAllVisibleItems(_this.props.items), length = filteredItems.length - 1, index = _this.getNextFocusable(_this.state.focusedItemIndex, length);
                _this.setState({
                    focusedItemIndex: index
                }), _this.scrollToFocused(index);
            }, _this.focusPreviousItem = function() {
                var filteredItems = _this.getAllVisibleItems(_this.props.items), length = filteredItems.length - 1, index = _this.getPrevFocusable(_this.state.focusedItemIndex, length);
                _this.setState({
                    focusedItemIndex: index
                }), _this.scrollToFocused(index);
            }, _this.focusItem = function(item) {
                var filteredItems = _this.getAllVisibleItems(_this.props.items), index = filteredItems.indexOf(item);
                _this.setState({
                    focusedItemIndex: index
                }), _this.scrollToFocused(index);
            }, _this.handleNativeSearch = function(event) {
                var _this$props = _this.props, selectedItem = _this$props.selectedItem, items = _this$props.items, eventKey = event.key, _this2 = _this, nativeSearchKey = _this2.nativeSearchKey, allItems = _this.getAllItems(items);
                _this.nativeSearchCounter ? nativeSearchKey += eventKey : nativeSearchKey = eventKey;
                var current = void 0 !== _this.state.focusedItemIndex ? _this.state.focusedItemIndex : allItems.indexOf(selectedItem), allItemsWithoutSelected = selectedItem && selectedItem.value ? allItems.filter(function(item) {
                    return item.value !== selectedItem.value;
                }) : allItems;
                if (_this.props.isOpen) {
                    var _matchingItem = _this.getNextNativeSearchItem(allItemsWithoutSelected, nativeSearchKey, current);
                    _this.focusItem(_matchingItem);
                } else {
                    var matchingItem = _this.getNextNativeSearchItem(allItems, nativeSearchKey, current);
                    _this.handleItemSelect(matchingItem, {
                        event: event
                    });
                }
                clearTimeout(_this.nativeSearchCounter), _this.nativeSearchCounter = setTimeout(_this.clearNativeSearch, 200), 
                _this.previousKey = eventKey, _this.nativeSearchKey = nativeSearchKey;
            }, _this.handleKeyboardInteractions = function(event) {
                var isSelectOpen = _this.props.isOpen;
                switch (event.key) {
                  case "ArrowDown":
                    event.preventDefault(), isSelectOpen || _this.onOpenChange({
                        event: event,
                        isOpen: !0
                    }), _this.focusNextItem();
                    break;

                  case "ArrowUp":
                    event.preventDefault(), isSelectOpen && _this.focusPreviousItem();
                    break;

                  case "Enter":
                    isSelectOpen && void 0 !== _this.state.focusedItemIndex && _this.handleItemSelect(_this.getAllVisibleItems(_this.props.items)[_this.state.focusedItemIndex], {
                        event: event
                    });
                    break;

                  default:
                    _this.props.hasAutocomplete || _this.handleNativeSearch(event);
                }
            }, _this.handleInputOnChange = function(event) {
                var value = event.target.value;
                value !== _this.props.filterValue && (_this.props.onFilterChange(value), _this.onOpenChange({
                    event: event,
                    isOpen: !0
                }));
            }, _this.handleTriggerClick = function(event) {
                _this.props.isDisabled || _this.onOpenChange({
                    event: event,
                    isOpen: !0
                });
            }, _this.handleItemSelect = function(item, attrs) {
                item && !item.isDisabled && (_this.props.onOpenChange({
                    isOpen: !1,
                    event: attrs.event
                }), _this.props.onSelected(item), _this.props.onFilterChange(item.content), _this.setState({
                    focusedItemIndex: void 0
                }));
            }, _this.renderItems = function(items) {
                var filteredItems = _this.filterItems(items);
                return filteredItems.length ? filteredItems.map(function(item, itemIndex) {
                    return _react2.default.createElement(_droplistItem2.default, (0, _extends3.default)({}, item, {
                        isFocused: itemIndex === _this.state.focusedItemIndex,
                        key: itemIndex,
                        onActivate: function(attrs) {
                            _this.handleItemSelect(item, attrs);
                        }
                    }), item.content);
                }) : _react2.default.createElement(_NothingWasFound2.default, {
                    noMatchesFound: _this.props.noMatchesFound
                });
            }, _this.renderGroups = function(groups) {
                return groups.map(function(group, groupIndex) {
                    return _react2.default.createElement(_droplistGroup2.default, {
                        heading: group.heading,
                        key: groupIndex
                    }, _this.renderItems(group.items));
                });
            }, _this.renderOptions = function(items) {
                return items.map(function(item, itemIndex) {
                    return _react2.default.createElement("option", {
                        disabled: item.isDisabled,
                        key: itemIndex,
                        value: item.value
                    }, item.content);
                });
            }, _this.renderOptGroups = function(groups) {
                return groups.map(function(group, groupIndex) {
                    return _react2.default.createElement("optgroup", {
                        label: group.heading,
                        key: groupIndex
                    }, _this.renderOptions(group.items));
                });
            }, _this.renderSelect = function() {
                return _react2.default.createElement("select", {
                    disabled: _this.props.isDisabled,
                    id: _this.props.id,
                    name: _this.props.name,
                    readOnly: !0,
                    required: _this.props.isRequired,
                    style: {
                        display: "none"
                    },
                    value: _this.props.selectedItem.value
                }, _react2.default.createElement("option", {
                    value: ""
                }), _this.renderOptGroups(_this.props.items));
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(StatelessSelect, _PureComponent), (0, _createClass3.default)(StatelessSelect, [ {
            key: "render",
            value: function() {
                var _this3 = this, classes = (0, _classnames2.default)([ _styles2.default.selectWrapper, (0, 
                _defineProperty3.default)({}, _styles2.default.fitContainer, this.props.shouldFitContainer) ]), triggerClasses = (0, 
                _classnames2.default)([ _styles2.default.trigger, (0, _defineProperty3.default)({}, _styles2.default.isOpen, this.props.isOpen) ]);
                // disabled because all of the accessibility is handled manually
                /* eslint-disable jsx-a11y/no-static-element-interactions */
                return _react2.default.createElement("div", {
                    className: classes,
                    onKeyDown: this.handleKeyboardInteractions,
                    ref: function(_ref5) {
                        _this3.containerNode = _ref5;
                    }
                }, this.renderSelect(), this.props.label ? _react2.default.createElement(_fieldBase.Label, {
                    htmlFor: this.props.id,
                    isFirstChild: this.props.isFirstChild,
                    isRequired: this.props.isRequired,
                    label: this.props.label
                }) : null, _react2.default.createElement(_droplist2.default, {
                    isKeyboardInteractionDisabled: !0,
                    isOpen: this.props.isOpen,
                    isTriggerDisabled: !0,
                    isTriggerNotTabbable: !0,
                    onOpenChange: this.onOpenChange,
                    position: this.props.position,
                    shouldFitContainer: !0,
                    trigger: _react2.default.createElement(_fieldBase.FieldBase, {
                        appearance: (0, _appearances.mapAppearanceToFieldBase)([ this.props.appearance ]),
                        isDisabled: this.props.isDisabled,
                        isFitContainerWidthEnabled: !0,
                        isFocused: this.props.isOpen || this.state.isFocused,
                        isInvalid: this.props.isInvalid,
                        isPaddingDisabled: !0,
                        onBlur: this.onBlur,
                        onFocus: this.onFocus
                    }, _react2.default.createElement("div", {
                        className: triggerClasses,
                        onClick: this.handleTriggerClick,
                        tabIndex: "0"
                    }, !this.props.hasAutocomplete || this.props.isDisabled ? _react2.default.createElement("div", {
                        className: _styles2.default.content
                    }, this.props.selectedItem.content || _react2.default.createElement("span", {
                        className: _styles2.default.placeholder
                    }, this.props.placeholder)) : _react2.default.createElement("div", {
                        className: _styles2.default.contentAutocomplete
                    }, _react2.default.createElement("input", {
                        onChange: this.handleInputOnChange,
                        placeholder: this.props.placeholder,
                        ref: function(_ref4) {
                            return _this3.inputNode = _ref4;
                        },
                        type: "text",
                        value: this.props.filterValue
                    })), _react2.default.createElement("div", {
                        className: _styles2.default.expand
                    }, _react2.default.createElement(_expand2.default, {
                        label: ""
                    }))))
                }, this.renderGroups(this.props.items)));
            }
        } ]), StatelessSelect;
    }(_react.PureComponent);
    StatelessSelect.propTypes = {
        appearance: _react.PropTypes.oneOf(_appearances.appearances.values),
        filterValue: _react.PropTypes.string,
        hasAutocomplete: _react.PropTypes.bool,
        id: _react.PropTypes.string,
        isDisabled: _react.PropTypes.bool,
        isFirstChild: _react.PropTypes.bool,
        isOpen: _react.PropTypes.bool,
        isRequired: _react.PropTypes.bool,
        isInvalid: _react.PropTypes.bool,
        items: _react.PropTypes.array,
        // eslint-disable-line react/forbid-prop-types
        label: _react.PropTypes.string,
        name: _react.PropTypes.string,
        noMatchesFound: _react.PropTypes.string,
        onSelected: _react.PropTypes.func,
        onFilterChange: _react.PropTypes.func,
        onOpenChange: _react.PropTypes.func,
        placeholder: _react.PropTypes.string,
        position: _react.PropTypes.string,
        shouldFocus: _react.PropTypes.bool,
        selectedItem: itemShape,
        shouldFitContainer: _react.PropTypes.bool
    }, StatelessSelect.defaultProps = {
        appearance: _appearances.appearances.default,
        filterValue: "",
        hasAutocomplete: !1,
        isOpen: !1,
        isRequired: !1,
        items: [],
        label: "",
        noMatchesFound: "No matches found",
        onFilterChange: function() {},
        onSelected: function() {},
        onOpenChange: function() {},
        placeholder: "",
        position: "bottom left",
        shouldFocus: !1,
        selectedItem: {}
    }, exports.default = StatelessSelect;
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/droplist");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/droplist-item");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/droplist-group");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/field-base");
}, /* 17 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(18);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 18 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._2XF8oMf0r5Ol3CDDqqDcFw{display:inline-block}._2XF8oMf0r5Ol3CDDqqDcFw._2rIN2V1E4oWs8bUF5KvB4{display:block}._2_GizVfgSKl-eNydy2RIL8{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;width:100%;min-height:32px}.ylIL5DG_6NF7QmeBzym1q{-webkit-box-flex:1;flex:1 1 auto;margin:6px 8px;white-space:nowrap}.ItjkgB0JMqaq-77Fwa8A2{-webkit-box-flex:1;flex:1 1 auto;white-space:nowrap;padding:0 8px}.ItjkgB0JMqaq-77Fwa8A2 input{padding:0;margin:0;background:none;border:0;min-height:32px;outline:0;font-size:14px;color:#172b4d}.ItjkgB0JMqaq-77Fwa8A2 input::-webkit-input-placeholder{font-size:14px;color:#6c798f}.ItjkgB0JMqaq-77Fwa8A2 input::-moz-placeholder{font-size:14px;color:#6c798f}.ItjkgB0JMqaq-77Fwa8A2 input:-ms-input-placeholder{font-size:14px;color:#6c798f}.ItjkgB0JMqaq-77Fwa8A2 input::placeholder{font-size:14px;color:#6c798f}._1Ol0jADfIQzx4J9bt76oXZ{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-flex:0;flex:0 0 24px;-webkit-box-pack:center;justify-content:center;margin:0 8px}._3DhxPTuhecMi7l7XHIkHLl{font-size:14px;color:#6c798f}._3SWl3ChhBKq4DNKotaOvGr{padding:6px 24px}", "" ]), 
    // exports
    exports.locals = {
        selectWrapper: "_2XF8oMf0r5Ol3CDDqqDcFw",
        selectWrapper: "_2XF8oMf0r5Ol3CDDqqDcFw",
        fitContainer: "_2rIN2V1E4oWs8bUF5KvB4",
        fitContainer: "_2rIN2V1E4oWs8bUF5KvB4",
        trigger: "_2_GizVfgSKl-eNydy2RIL8",
        trigger: "_2_GizVfgSKl-eNydy2RIL8",
        content: "ylIL5DG_6NF7QmeBzym1q",
        content: "ylIL5DG_6NF7QmeBzym1q",
        contentAutocomplete: "ItjkgB0JMqaq-77Fwa8A2",
        contentAutocomplete: "ItjkgB0JMqaq-77Fwa8A2",
        expand: "_1Ol0jADfIQzx4J9bt76oXZ",
        expand: "_1Ol0jADfIQzx4J9bt76oXZ",
        placeholder: "_3DhxPTuhecMi7l7XHIkHLl",
        placeholder: "_3DhxPTuhecMi7l7XHIkHLl",
        nothing: "_3SWl3ChhBKq4DNKotaOvGr",
        nothing: "_3SWl3ChhBKq4DNKotaOvGr"
    };
}, /* 19 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 21 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 22 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/icon/glyph/expand");
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _styles = __webpack_require__(18), NothingWasFound = function(_PureComponent) {
        function NothingWasFound() {
            return (0, _classCallCheck3.default)(this, NothingWasFound), (0, _possibleConstructorReturn3.default)(this, (NothingWasFound.__proto__ || (0, 
            _getPrototypeOf2.default)(NothingWasFound)).apply(this, arguments));
        }
        return (0, _inherits3.default)(NothingWasFound, _PureComponent), (0, _createClass3.default)(NothingWasFound, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: _styles.locals.nothing
                }, this.props.noMatchesFound);
            }
        } ]), NothingWasFound;
    }(_react.PureComponent);
    NothingWasFound.propTypes = {
        noMatchesFound: _react.PropTypes.string
    }, exports.default = NothingWasFound;
}, /* 24 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var appearancesMap = (exports.appearances = {
        values: [ "default", "subtle" ],
        default: "default"
    }, {
        default: "standard",
        subtle: "subtle"
    });
    exports.mapAppearanceToFieldBase = function(appearance) {
        return appearancesMap[appearance];
    };
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/@atlaskit/single-select/dist/bundle-cjs.js
// module id = 301
// module chunks = 0